// externalConnectionsApi.ts

import { BadgeMovementData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';

const baseApi = apiResource<BadgeMovementData>('badge-movements');

const apiBaseUrl = getApiBaseUrl();
export const API_URL = apiBaseUrl + '/v2';
import apiFetch from 'common/services/apiFetch';

async function request<T>(
	url: string,
	method: string,
	token: string,
	body?: Partial<T>
): Promise<T> {
	const res = await apiFetch(`${API_URL}${url}`, {
		method,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: body ? JSON.stringify(body) : undefined,
	});
	if (!res.ok) throw new Error(`Failed to ${method} ${url}`);
	return method === 'DELETE' ? (undefined as unknown as T) : res.json();
}

const baseUrl = `/badge-movements`;

export const badgeMovementsApi = {
	...baseApi, // CRUD générique

	listByBadge: (token: string, badgeNumber: string) => {
		if (badgeNumber === 'all') {
			return request<BadgeMovementData[]>(`${baseUrl}`, 'GET', token);
		} else {
			return request<BadgeMovementData[]>(
				`${baseUrl}/by-badge-number/${badgeNumber}`,
				'GET',
				token
			);
		}
	},
};
